import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import sset from "../sset.mp4";

const Sset = () => {
  const navigate = useNavigate();
  const firstpage = () => {
    navigate("/page7", {
      state: { hexkey, hexuserInput, KeyValue, userInput },
    });
  };
  const second = () => {
    navigate("/page4", {
      state: {
        hexkey,
        hexuserInput,
        KeyValue,
        userInput,
      },
    });
  };

  const location = useLocation();
  const userInput = location.state.userInput;
  const KeyValue = location.state.KeyValue;
  const hexuserInput = location.state.hexuserInput;
  const hexkey = location.state.hexkey;

  return (
    <>
    <div>
    <div className="mx-auto align-middle justify-cente text-center">
        <h1 className=" font-semibold text-3xl pb-5">Generation of subkeys S</h1>
        <p>
         We see how S set subkeys are produces
          <br />The key provided is divided into words and they are multiplied with RS Matrix as shown
          <br />The multiplication is in Galois Field 2^8 and the primitive polynomial is x<sup>8</sup> + x<sup>6</sup> + x<sup>3</sup> + x<sup>2</sup> + 1
        </p>
      </div>
      
      <video autoPlay loop muted className="mx-auto align-middle justify-cente text-center max-h-96" >
      <source src={sset} type="video/mp4">
        </source>
      </video>

    </div>
    <div class="button-holder">
    <div class="prev-button" onClick={firstpage}>
        PREVIOUS
    </div>
    </div>
  </>
  );
};

export default Sset;
